import { createSelector } from 'reselect'

const paidAdsSelector = (state) =>
  (state.paidAds && state.paidAds.paidAds) || []
const adCampaignDataSelector = (state) =>
  (state.ad && state.ad.adCampaignData) || {}
const adStateSelector = (state) => state.ad && state.ad

export const selectPaidAds = createSelector(
  [paidAdsSelector],
  (paidAds) => {
    return {
      paidAds,
    }
  },
)

export const selectAdCampaignData = createSelector(
  [adCampaignDataSelector],
  (adCampaignData) => {
    return {
      adCampaignData,
    }
  },
)

export const selectPublishAdCampaignState = createSelector(
  [adStateSelector],
  (ad) => {
    return {
      publishAdCampaignState: {
        status: ad.publishAdCampaignStatus,
        errors: ad.publishAdCampaignErrors,
      },
    }
  },
)

export const selectCreateAdCampaignState = createSelector(
  [adStateSelector],
  (ad) => {
    return {
      createAdCampaignState: {
        status: ad.createAdCampaignStatus,
        errors: ad.createAdCampaignErrors,
      },
    }
  },
)

export const selectPostAdCampaignInvitationsState = createSelector(
  [adStateSelector],
  (ad) => {
    return {
      postAdCampaignInvitationsState: {
        status: ad.postAdCampaignInvitationsStatus,
        errors: ad.postAdCampaignInvitationsErrors,
      },
    }
  },
)
